/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { ptBR } from '@mui/material/locale';
import {
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  Button,
  Tooltip,
} from '@mui/material';
import { FaEdit } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/pt-br';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import axios from '../../services/axios';
import Loading from '../../components/Loading';

const textData = 'Viagens do Motorista';
const tableRoute = 'controleviagens';
const tableData = 'viagens';

export default function Cadastro() {
  const [table, setTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const idUser = useSelector((state) => state.auth.user.id);
  let idMotorista = null;

  const getData = useCallback(async () => {
    try {
      setIsLoading(true);
      const responseUser = await axios.get(`/users/${idUser}`);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      idMotorista = responseUser.data.Motoristum.id;

      const response = await axios.get(
        `/${tableData}/motorista/${idMotorista}`
      );
      setTable(response.data);
    } catch (err) {
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/home`);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, idMotorista, idUser]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'Nr.',
        size: 80,
      },
      {
        accessorKey: 'saida',
        accessorFn: (row) =>
          row.saida ? moment(row.saida).format('DD/MM/YYYY') : null,
        header: 'Data Saída',
        size: 80,
      },
      {
        accessorKey: 'retorno',
        accessorFn: (row) =>
          row.retorno ? moment(row.retorno).format('DD/MM/YYYY') : null,
        header: 'Data Retorno',
        size: 80,
      },
      {
        accessorKey: 'Motoristum.nome',
        header: 'Nome Motorista',
        size: 80,
      },
      {
        accessorKey: 'Veiculo.placa',
        accessorFn: (row) => row.Veiculo?.placa || null,
        header: 'Placa',
        size: 80,
      },
    ],
    []
  );

  return (
    <ContainerGrid>
      <Loading isLoading={isLoading} />
      <Title>{`${textData}`}</Title>
      <ThemeProvider theme={createTheme(theme, ptBR)}>
        <MaterialReactTable
          columns={columns}
          data={table}
          enableRowActions
          enableColumnActions={false}
          enableColumnFilters={false}
          enablePagination={false}
          enableSorting={false}
          enableBottomToolbar={false}
          enableTopToolbar={false}
          muiTableBodyRowProps={{ hover: true }}
          localization={MRT_Localization_PT_BR}
          renderRowActions={({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Editar">
                <Link to={`/${tableRoute}/${row.getValue('id')}/motorista`}>
                  <FaEdit size={50} />
                </Link>
              </Tooltip>
              <Tooltip
                arrow
                placement="left"
                title={
                  row.getValue('saida') && row.getValue('retorno')
                    ? 'Viagem Encerrada'
                    : row.getValue('saida')
                    ? 'Viagem em Andamento'
                    : 'Viagem em Aberto'
                }
              >
                <div>
                  <Button
                    disabled
                    style={{
                      backgroundColor:
                        row.getValue('saida') && row.getValue('retorno')
                          ? 'blue'
                          : row.getValue('saida')
                          ? 'orange'
                          : 'green',
                      color: '#FFF',
                    }}
                  >
                    {row.getValue('saida') && row.getValue('retorno')
                      ? 'Viagem Encerrada'
                      : row.getValue('saida')
                      ? 'Viagem em Andamento'
                      : 'Viagem em Aberto'}
                  </Button>
                </div>
              </Tooltip>
            </Box>
          )}
        />
      </ThemeProvider>
    </ContainerGrid>
  );
}
